export default __webpack_public_path__ + "static/media/flag-button-highlight@2x.4ffde1a3.png";